var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isAdmin && _vm.status != 'FINISH')?_c('button',{staticClass:"btn btn-small",on:{"click":function($event){$event.preventDefault();return _vm.$emit('deleteItem')}}},[_vm._v(" × ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }